import clsx from 'clsx'
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {useLayout} from '../../core/LayoutProvider'
import {usePageData} from '../../core/PageData'

const DefaultTitle: FC = () => {
  const { pageTitle, pageDescription, pageBreadcrumbs} = usePageData()
  const {config, classes} = useLayout()
  console.log("this page desc "+pageTitle);
  //let pageTitle= 'Contact List';
  return (
    <div
      id='kt_page_title'
      data-kt-swapper='true'
      data-kt-swapper-mode='prepend'
      data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      className={clsx('page-title text-black d-flex flex-column', classes.pageTitle.join(' '))}
    >
      {/* begin::Title */}
      
      {pageTitle && (
        <h3 className='d-flex align-items-center text-dark fw-bolder my-1 fs-5'>
          {pageTitle}
          {pageDescription && config.pageTitle && config.pageTitle.description && (
            <>
              <span className='h-20px border-gray-200 border-start ms-3 mx-2'></span>
              <small className='text-muted fs-7 fw-bold my-1 ms-1'>{pageDescription}</small>
            </>
          )}
        </h3>
      )} 
      {/* end::Title */}

      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.pageTitle &&
        config.pageTitle.breadCrumbs && (
          <>
            {config.pageTitle.direction === 'row' && (
              // <span className='h-20px border-gray-200 border-start mx-4'></span>
              <span></span>
            )}
            <ul className='breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1'>
              {Array.from(pageBreadcrumbs).map((item, index) => (
                <li
                  className={clsx('breadcrumb-item', {
                    'text-dark': !item.isSeparator && item.isActive,
                    'text-muted': !item.isSeparator && !item.isActive,
                  })}
                  key={`${item.path}${index}`}
                >
                  {/* {!item.isSeparator ? (
                    <Link className='text-muted text-hover-primary' to={item.path}>
                      {item.title}
                    </Link>
                  ) : (
                    <span className='bullet bg-gray-200 w-5px h-2px'></span>
                  )} */}
                  {!item.isSeparator ? (
                  item.path && item.path !== "" ? (
                    <Link className='text-muted text-hover-primary' to={item.path}>
                      {item.title}
                    </Link>
                   ) : 
                    <div 
                      onClick={item.onClick}
                      className='text-muted text-hover-primary'
                    >
                      {item.title}
                      </div>
                  ) : (
                    // <span className='bullet bg-gray-200 w-5px h-2px'></span>
                    <span className="w-5px h-2px"></span>
                  )}
                </li>
              ))}
              <li className='breadcrumb-item text-black'>{pageTitle}</li>
            </ul>
          </>
        )}
    </div>
  )
}

export {DefaultTitle}
